import classes from "./CustomTextForm.module.css"
import React from 'react';

const CustomTextForm = (props) => {
  return (
    <input {...props} className={classes.customTextForm} />
  );
};

export default CustomTextForm;